import { defineComponent as _defineComponent } from 'vue'
import {
  ContentDisplay,
  BaseText,
  Heading,
  ProgressBar
} from '@warrenbrasil/nebraska-web';

import { CustomOperation } from '@/modules/trade/services/custom-operations';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

interface Props {
  customOperationData: CustomOperation;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Progress',
  props: {
    customOperationData: null
  },
  setup(__props: any) {



return { __sfc: true,ContentDisplay, BaseText, Heading, ProgressBar, NebraskaColors }
}

})